import { useQuery } from '@tanstack/react-query';
import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';
import alb from 'services/api/alb';

import {
	FilterHierarchyApply,
	IFilterHierarchy,
} from '../types/planning.types';

export interface ISavePlanning {
	cycleId: number;
	filters: FilterHierarchyApply;
}

const fetchApplyFilterPlanning = async (
	params: ISavePlanning,
	planningType: PlanningTypes
): Promise<IFilterHierarchy> => {
	const { cycleId, filters } = params;
	const response = await alb.post('/apportionment/apply-filters', {
		cycle_id: cycleId,
		filters,
		planning_type: planningType,
	});
	return response.data;
};

export const useApplyFilterPlanning = (
	params: ISavePlanning | undefined,
	planningType: PlanningTypes
) => {
	return useQuery({
		queryKey: [
			'apply-filters',
			params?.cycleId || '',
			planningType,
			JSON.stringify(params?.filters),
		],
		queryFn: () => {
			if (!params) throw new Error('Parâmetros não fornecidos');
			return fetchApplyFilterPlanning(params, planningType);
		},
		enabled: !!params?.cycleId,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
	});
};
